app.controller('reportsController', function($http, $scope, $stateParams, $location, dataService, DTColumnBuilder, pageConfig, pageHandler, $timeout) {

	//initialise survey specific views
	pageHandler.initViews(pageConfig, $scope);

	//initialise filters
	var filtersLoaded = pageHandler.initFilters(pageConfig, $scope);
	
	if(filtersLoaded)
	{	
		//initialise components
		pageHandler.initComponents(pageConfig, $scope);
	
		//show loading on components
		pageHandler.showLoading(pageConfig, $scope);

		//request data for components
		pageHandler.requestDataForComponents(pageConfig, $scope);
		
		//initialize export feature
		pageHandler.initPageExports(pageConfig, $scope);
	}
	
	var reportHeading = {};
	var r_dealer_name = (typeof($scope.$parent.breadCrumb.filters[1]) != 'undefined') ? $scope.$parent.breadCrumb.filters[1].label : '';
	var r_data_label = (typeof($scope.$parent.breadCrumb.filters[2]) != 'undefined') ? $scope.$parent.breadCrumb.filters[2].label : '';
	reportHeading = {'dealer_name' : r_dealer_name, 'date_label': r_data_label};
	$scope.reportHeading = reportHeading;

	//=======page specific methods and processes==========//

	//show transcript
	$scope.goToTranscript = function(rowData, component, componentKey)
	{
		var survey_id = (typeof(rowData[component.config.rowclick_survey_id]) != 'undefined') ? rowData[component.config.rowclick_survey_id] : null;
		var submenu_key = (typeof(rowData[component.config.rowclick_submenu_key]) != 'undefined') ? rowData[component.config.rowclick_submenu_key] : null;

		var params = [];
		params['filter_transcript_' + submenu_key] = survey_id;
		var filter_transcript_return = {
			"page" : $scope.appState.page,
			"submenu_key" : $scope.appState.submenu_key
		};
		params['filter_transcript_return_'+submenu_key] = window.encodeURI(JSON.stringify(filter_transcript_return));
		$scope.goToPage('surveys', params, submenu_key);
	}
});
